import React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 69"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="c">
        <stop stopColor="#4AB6F5" offset="0%" />
        <stop stopColor="#227BF9" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b">
        <stop stopColor="#7DCFFF" offset="0%" />
        <stop stopColor="#60A2FE" offset="100%" />
      </linearGradient>
      <filter
        x="-44%"
        y="-37%"
        width="187.9%"
        height="173.9%"
        filterUnits="objectBoundingBox"
        id="a"
      >
        <feOffset dy={3} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={5}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#a)" fill="none" fillRule="evenodd">
      <path
        d="M29 5c6.35 0 12.1 2.59 16.261 6.774A23.132 23.132 0 0 1 52 28.136c0 5.526-3.422 12.305-7.652 18.275C38.784 54.26 31.73 61 29 61c-2.73 0-9.784-6.74-15.348-14.59C9.422 40.442 6 33.663 6 28.137c0-6.39 2.575-12.174 6.739-16.362C16.9 7.59 22.649 5 29 5Z"
        stroke="url(#b)"
        strokeWidth={2}
        fill="url(#c)"
      />
      <path
        d="M35.192 21.576v15.437c0 .098.084.178.185.178h1.017c.102 0 .185-.08.185-.178V23.985c0-.098.083-.179.185-.179h1.663c1.021 0 1.849.8 1.849 1.785v11.422c0 .098.083.178.185.178h.554c.102 0 .185.08.185.178v1.428a.182.182 0 0 1-.185.179H19.203a.182.182 0 0 1-.185-.179V37.37c0-.098.083-.178.185-.178h1.017c.102 0 .185-.08.185-.178V21.576c0-1.479 1.24-2.677 2.772-2.677h9.243c1.531 0 2.772 1.198 2.772 2.677Zm-5.21 6.246H25.8c-.07 0-.126.133-.126.297v1.636c0 .164.057.298.126.298h4.183c.07 0 .127-.134.127-.298V28.12c0-.164-.057-.297-.127-.297Zm2.168-4.462h-8.518c-.098 0-.177.133-.177.298v1.636c0 .163.08.297.177.297h8.518c.098 0 .177-.133.177-.297v-1.636c0-.165-.08-.298-.177-.298Z"
        fill="#E2F2FF"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
